import { beFspDownloadImportFile, type FspFileObj } from "Api/beFsp";
import {
  beRecipientApiDeleteImport,
  beRecipientApiDeleteImports,
  beRecipientApiGetGroupDetails,
  beRecipientApiGetRunningImport,
  beRecipientApiSearchImports,
  beRecipientApiStartImports,
  beRecipientApiStopImports,
} from "Api/beRecipientApiTS";
import { STORE_KEY_ID_LIST } from "Constants";
import type {
  DeleteImportsRequest,
  GetRunningImportResp,
  ImportsResp,
  SearchImportsData,
  SearchImportsRequest,
  SearchImportsResp,
} from "Types/beRecipientsApi";
import { storeGet } from "mailup-react-helpers";

export const searchImports = async (
  dataIn: SearchImportsData,
  requstBody: SearchImportsRequest,
): Promise<SearchImportsResp> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  const newItems = await beRecipientApiSearchImports(
    idList,
    dataIn,
    requstBody,
  );

  const itemsWithGroups = await Promise.all(
    newItems.Items.map(async (item) => {
      if (!item.IdGroups || item.IdGroups.length === 0) {
        return { ...item, Groups: [] };
      }
      const groupDetails = await Promise.all(
        item.IdGroups.map((id) =>
          beRecipientApiGetGroupDetails(id).catch(() => null),
        ),
      );
      const groups = groupDetails
        .filter((g) => g !== null)
        .map((g) => `${g.Id} - ${g.Name}`);
      return { ...item, Groups: groups };
    }),
  );

  return { ...newItems, Items: itemsWithGroups };
};

export const deleteImports = async (
  requstBody: DeleteImportsRequest,
): Promise<ImportsResp> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  return await beRecipientApiDeleteImports(idList, requstBody);
};

export const deleteImport = async (idImport: number): Promise<ImportsResp> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  return await beRecipientApiDeleteImport(idList, idImport);
};

export const startImports = async (): Promise<ImportsResp> => {
  const idList = storeGet(STORE_KEY_ID_LIST);
  return await beRecipientApiStartImports(idList);
};

export const stopImports = async (): Promise<ImportsResp> => {
  const idList = storeGet(STORE_KEY_ID_LIST);

  const ret = await beRecipientApiStopImports(idList);

  return ret;
};

export const downloadImportFile = async (
  fileName: string,
): Promise<FspFileObj> => {
  const idList = storeGet(STORE_KEY_ID_LIST);
  return await beFspDownloadImportFile(idList, fileName);
};

export const getRunningImport = async (): Promise<GetRunningImportResp> => {
  return await beRecipientApiGetRunningImport();
};
